import { LabelTag } from "react-migration/components/LabelTag";
import { Checkbox, CheckboxState } from "react-migration/components/DeprecatedCheckbox";
import { debounce } from "lodash";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { logEventV2 } from "react-migration/lib/util/logEventV2";

export interface ListSearchInputProps {
  value: string;
  onChange(searchInput: string): void;
  excludeValue?: boolean;
  setExcludeValue?: (value: boolean) => void;
}

const debouncedLogevent = debounce(
  (text: string) => logEventV2({ name: "Designations list filter", properties: { text } }),
  1000
);

export function ListSearchInput({ value, onChange, excludeValue, setExcludeValue }: ListSearchInputProps) {
  const { t } = useTranslation();

  function handleFilterTextChange(text: string) {
    debouncedLogevent(text);
    onChange(text);
  }

  return (
    <div data-testid="list-search-input" className="sticky top-0 z-10 items-center w-full p-2 space-y-2 bg-white">
      <div className="flex">
        <i className="mr-2 text-xl icon-lt-search-line text-neutral-600" />
        <input
          type="text"
          max={24}
          placeholder={t("domains.constraints.components.designation.filter_placeholder")}
          value={value}
          onChange={(e) => handleFilterTextChange(e.target.value.replace(/(?![\w ])./g, ""))}
          pattern="\w"
          className="min-w-[65px] w-full bg-white peer font-sans text-sm leading-none rounded-sm py-1.5 pl-2.5 pr-1 border border-neutral-300 focus:border-platform-500 placeholder:text-text-base-tertiary"
        />
        {!!value.length && (
          <button
            className="absolute right-1.5 pr-2 cursor-pointer text-neutral-400 focus:text-neutral-500 hover:text-neutral-500"
            onClick={() => onChange("")}
          >
            <i className="text-xl icon-lt-close-line" />
          </button>
        )}
      </div>
      {setExcludeValue && (
        <div className="flex justify-end w-full">
          <LabelTag className="italic" text="Exclude terms..." />
          <Checkbox
            value={excludeValue ? CheckboxState.CHECKED : CheckboxState.EMPTY}
            onChange={() => setExcludeValue(!excludeValue)}
          />
        </div>
      )}
    </div>
  );
}
